import { Trans } from '@lingui/react/macro';
import { Label, Switch } from '@utima/ui';

export type MineOnlyToggleProps = {
  value: boolean;
  onChange: (value: boolean) => void;
};

/**
 * Partner-only list filter toggling between "all hub clients" and "mine only"
 * (clients attributed to the current user). UI-only — it never changes what the
 * partner can access, switch to, or bill.
 */
export function MineOnlyToggle({ value, onChange }: MineOnlyToggleProps) {
  return (
    <div className='flex items-center gap-2'>
      <Switch
        id='mine-only-toggle'
        data-cta='admin-partner-mine-only-toggle'
        size='sm'
        checked={value}
        onCheckedChange={onChange}
      />
      <Label
        htmlFor='mine-only-toggle'
        className='cursor-pointer text-sm font-normal text-muted-fg'
      >
        <Trans>Mine clients only</Trans>
      </Label>
    </div>
  );
}
